import MobileSliderPagesWrapper from "../components/MobileSliderPagesWrapper.jsx";
import LiteTradeSelectAsset
    from "../../../../modules/LiteTrade/components/LiteTradeSelectAsset/LiteTradeSelectAsset.jsx";
import React from "react";
import MobileSliderPagesHeader from "../components/MobileSliderPagesHeader.jsx";
import { MobileSliderPagesContentStyled } from "../components/styled/MobileSliderPagesStyled.js";

function SlideMobileSelectAsset() {
    return <MobileSliderPagesWrapper backgroundColor="var(--color-base-secondary)">
        <div className="h-100 d-flex flex-column">
            <MobileSliderPagesHeader goBack/>
            <MobileSliderPagesContentStyled>
                <LiteTradeSelectAsset/>
            </MobileSliderPagesContentStyled>
        </div>
    </MobileSliderPagesWrapper>
}

export default SlideMobileSelectAsset;
